import React from 'react';
import { PASSWORD_GENERATOR_URL } from '@/config/urls/passwordUrls';

const vpsOci = {
  myPlan: {
    title: 'Meu plano',
    reboot: 'Reiniciar',
    rebootModal: {
      title: 'Reiniciar máquina (reboot)',
      message: productName => (
        <>
          <div>
            Você tem certeza que deseja reiniciar a sua
            {' '}
            <strong>{productName}</strong>
            ?
          </div>
          <p>
            A reinicialização levará cerca de 15 minutos e durante esse período todos os seus serviços ficarão indisponíveis.
          </p>
        </>
      ),
      cancel: 'Cancelar',
      checkRebootHistory: 'Ver histórico de reboots',
      confirm: 'Sim, reiniciar agora',
    },
    rebootHistory: {
      title: 'Histórico de reboots',
      message: productName => (
        <>
          Últimas reinicializações da sua
          {' '}
          <strong>
            {productName}
          </strong>
          .
        </>
      ),
      date: 'Data',
      time: 'Horário',
      goBack: 'Voltar',
    },
    feedback: {
      loading: 'Pode fechar esta janela. O reinício segue em segundo plano... retorne em breve para acompanhar.',
      success: 'VPS reiniciado com sucesso!',
      error: 'Não foi possível reiniciar agora. Por favor, tente novamente mais tarde.',
    },
  },
  status: {
    online: 'Online',
    offline: 'Offline',
    processing: 'Processando',
  },
  infoVps: {
    title: {
      text: 'Informações da VPS',
      tooltip: 'Tudo o que identifica o seu servidor.',
    },
    domain: 'Domínio primário',
    serverIp: 'IP atribuído',
    datacenter: 'Localização do servidor',
    processor: 'Processador',
    memory: 'Memória RAM',
    disk: 'Armazenamento',
  },
  infoSsh: {
    title: {
      text: 'Acesso SSH',
      tooltip: 'Copie essas informações pra se conectar via SSH pelo terminal da sua preferência. É o caminho pra acessar diretamente o ambiente da sua VPS.',
    },
    serverIp: 'IP',
    serverPort: 'Porta',
    user: 'Usuário',
    password: 'Senha',
    changePassword: 'Alterar senha',
    changePasswordModal: {
      title: 'Trocar senha de acesso SSH',
      newPassword: 'Nova senha',
      confirmPassword: 'Confirmar nova senha',
      passwordRequirements: 'Sua senha deve ter:',
      requirementUppercaseLowercase: 'Incluir caracteres maiúsculos e minúsculos',
      requirementNumber: 'Incluir pelo menos 1 número',
      requirementSymbol: 'Incluir pelo menos 1 símbolo',
      requirementLength: 'Ter pelo menos 8 caracteres',
      requirementMatch: 'Ser a mesma em ambos os campos',
      alertMessage: {
        text: 'Caso você tenha dificuldade para gerar uma senha forte e segura, veja nosso',
        link: {
          text: 'gerador de senhas.',
          href: PASSWORD_GENERATOR_URL,
        },
      },
      newInstallation: {
        title: 'Defina uma nova senha de acesso SSH',
        description: 'A instalação da sua VPS foi concluída! Agora, crie uma nova senha para acessar via SSH.',
      },
      cancel: 'Cancelar',
      save: 'Salvar senha',
      success: 'Senha de acesso SSH alterada!',
      error: 'Senha de acesso SSH não alterada. Por favor, tente novamente.',
    },
    terminal: {
      buttonLabel: 'Abrir terminal',
      modal: {
        error: {
          title: 'Erro ao abrir o terminal do navegador',
          message: 'Não foi possível carregar o terminal pelo navegador neste momento. Tente novamente mais tarde ou',
          link: {
            text: 'acesse sua VPS por outro terminal de sua preferência.',
            url: 'https://suporte.hostgator.com.br/hc/pt-br/articles/30812824748051-Como-acessar-um-servidor-via-SSH',
          },
          confirmButton: 'Entendi',
        },
      },
    },
  },
  management: {
    title: {
      text: 'Gerenciamento',
      tooltip: 'Aqui você gerencia o sistema operacional e acessa painéis ou aplicações que estão adicionados na sua VPS.',
    },
    items: [
      {
        slug: 'so-apps',
        name: 'SO e aplicações',
      },
      {
        slug: 'backup',
        name: 'Backup',
        info: 'Último backup: ',
      },
      {
        slug: 'snapshot',
        name: 'Snapshot',
        info: 'Último snapshot: ',
      },
      {
        slug: 'ssh-keys',
        name: 'Chaves SSH',
      },
      {
        slug: 'n8n',
        name: 'Acesso n8n',
      },
      {
        slug: 'cpanel',
        name: 'Acesso WHM',
      },
      {
        slug: 'plesk',
        name: 'Acesso Plesk',
      },
      {
        slug: 'wordpress',
        name: 'WordPress',
      },
      {
        slug: 'wordpress-1-clique',
        name: 'WordPress',
      },
      {
        slug: 'wordpress-openlitespeed',
        name: 'WordPress',
      },
      {
        slug: 'docker',
        name: 'Docker',
      },
      {
        slug: 'moodle',
        name: 'Moodle',
      },
      {
        slug: 'node-js',
        name: 'Node.js',
      },
      {
        slug: 'woocommerce',
        name: 'WooCommerce',
      },
      {
        slug: 'pterodactyl',
        name: 'Pterodactyl',
      },
      {
        slug: 'laravel',
        name: 'Laravel',
      },
      {
        slug: 'cyberpanel',
        name: 'CyberPanel',
      },
      {
        slug: 'magento',
        name: 'Magento',
      },
      {
        slug: 'supabase',
        name: 'Supabase',
      },
      {
        slug: 'kubernetes-k3s',
        name: 'Kubernetes K3S',
      },
      {
        slug: 'directadmin',
        name: 'DirectAdmin',
      },
      {
        slug: 'easypanel',
        name: 'EasyPanel',
      },
      {
        slug: 'webmin',
        name: 'Webmin',
      },
      {
        slug: 'virtualmin',
        name: 'Virtualmin',
      },
      {
        slug: 'openclaw',
        name: 'OpenClaw',
      },
    ],
  },
  planDetails: {
    title: 'Detalhes do plano',
    registerDate: 'Data de contratação',
    nextDueDate: 'Vencimento em',
    billingCycle: 'Ciclo',
    paymentMethod: 'Método de pagamento',
    upgradeButton: 'Fazer upgrade',
    form: {
      title: 'Upgrade de Plano',
      defaultSelectedNeed: 'Upgrade de Plano - VPS OCI',
    },
  },
  changePlan: {
    hireBanner: {
      title: 'Potencialize sua VPS',
      description: 'Adicione o painel cPanel ou crie automações com n8n e leve seu servidor a outro nível',
      button: 'Contratar',
    },
    form: {
      title: 'Alteração de Plano',
      defaultSelectedNeed: 'Alteração de Plano',
    },
  },
  helpLinks: {
    helpCenterButton: 'Acessar central de ajuda',
    tourButton: 'Ver tour guiado novamente',
  },
  welcomeModal: {
    title: 'Boas-vindas à sua VPS HostGator!',
    description: (
      <>
        <p>Que bom ter você por aqui!</p>
        <p>Este é o painel onde você gerencia seu servidor e deixa tudo do seu jeito. Aqui, você pode instalar aplicações, painéis de controle ou automações. </p>
        <p>Agora, vou te mostrar onde encontrar as principais informações e funcionalidades da sua VPS.</p>
      </>
    ),
    buttonLabel: 'Iniciar tour guiado',
  },
  guidedTour: {
    stepIndicator: (current, total) => `${current} de ${total}`,
    nextButton: 'Próximo',
    finishButton: 'Finalizar',
    steps: [
      {
        title: 'Sua nova VPS',
        description: 'Aqui você visualiza e controla o estado do seu servidor e também pode reiniciar quando precisar.',
      },
      {
        title: 'Dados principais da sua VPS',
        description: (
          <>
            <p>
              Tudo o que identifica o seu servidor. Em breve, você conseguirá monitorar o desempenho da sua VPS por aqui.
            </p>
            <p>
              <strong>Dica:</strong>
              {' '}
              o ícone ⓘ ao lado dos títulos traz mais detalhes sempre que precisar.
            </p>
          </>
        ),
      },
      {
        title: 'Acesso direto ao servidor',
        description: 'Copie essas informações pra se conectar via SSH pelo terminal da sua preferência. É o caminho pra acessar diretamente o ambiente da sua VPS.',
      },
      {
        title: 'Ferramentas do dia a dia',
        description: 'Aqui você gerencia o sistema operacional e acessa painéis ou aplicações que estão adicionados na sua VPS.',
      },
    ],
  },
  store: {
    details: {
      title: 'Sistemas operacionais e aplicações',
      description: 'Os Sistemas Operacionais e Aplicações definem como sua VPS funciona e o que ela pode fazer. Escolha e solicite a instalação ou reinstalação conforme suas necessidades.',
      operationalSystems: {
        almalinux: {
          name: 'AlmaLinux',
          description: 'Alternativa gratuita ao RHEL, com foco em estabilidade, desempenho e compatibilidade para ambientes empresariais.',
        },
        ubuntu: {
          name: 'Ubuntu',
          description: 'Distribuição Linux baseada no Debian, gratuita e fácil de usar, com suporte de longo prazo e foco em estabilidade e segurança.',
        },
        debian: {
          name: 'Debian',
          description: 'Sistema Linux estável e seguro, ideal para servidores e ambientes críticos, com pacotes atualizados e suporte de comunidade.',
        },
        rockylinux: {
          name: 'Rocky Linux',
          description: 'Distribuição compatível com RHEL, voltada para uso corporativo, oferecendo alto desempenho, segurança e confiabilidade.',
        },
      },
      panels: {
        cpanel: {
          name: 'cPanel',
          description: 'Painel intuitivo e completo para gerenciamento de sites e servidores, ideal para hospedagens com foco em desempenho e automação.',
        },
        plesk: {
          name: 'Plesk',
          description: 'Painel moderno e fácil de usar, permite gerenciar sites, domínios e e-mails com praticidade, integrando recursos de segurança e backups.',
        },
        cyberpanel: {
          name: 'CyberPanel',
          description: 'Distribuição Linux baseada no Debian, gratuita e fácil de usar, com suporte de longo prazo e foco em estabilidade e segurança.',
        },
        webmin: {
          name: 'Webmin',
          description: 'Painel de administração baseado na web, versátil e personalizável, ideal para quem busca controle total do servidor Linux.',
        },
        easypanel: {
          name: 'EasyPanel',
          description: 'Painel leve e intuitivo, voltado para usuários que desejam simplicidade no gerenciamento de servidores e sites.',
        },
        virtualmin: {
          name: 'Virtualmin',
          description: 'Painel completo e flexível, voltado para usuários que precisam de controle avançado no gerenciamento de servidores, domínios, e serviços integrados.',
        },
      },
      applications: {
        n8n: {
          name: 'n8n',
          description: 'Ferramenta de automação pronta para uso, permite criar fluxos e integrações entre sistemas sem código.',
        },
        'wordpress-1-clique': {
          name: 'WordPress 1-clique',
          description: 'Instalação rápida e automática do WordPress, ideal para criar sites e blogs em poucos minutos.',
        },
        'wordpress-openlitespeed': {
          name: 'WordPress otimizado com LiteSpeed/OLS',
          description: 'Versão ajustada para máximo desempenho e velocidade, com cache LiteSpeed nativo e alta eficiência.',
        },
        docker: {
          name: 'Docker',
          description: 'Plataforma que empacota aplicações e seus ambientes em contêineres, garantindo portabilidade e execução consistente em qualquer servidor.',
        },
        'node-js': {
          name: 'Node.js',
          description: 'Ambiente que permite rodar JavaScript no servidor para criar APIs e aplicações rápidas e leves, ideal para desenvolvedores e projetos modernos.',
        },
        moodle: {
          name: 'Moodle',
          description: 'Plataforma educacional open source, perfeita para criar e gerenciar cursos e ambientes de aprendizado online.',
        },
        pterodactyl: {
          name: 'Pterodactyl',
          description: 'Painel de gerenciamento de servidores de jogos, seguro e simples, voltado para hospedagem de games.',
        },
        magento: {
          name: 'Magento',
          description: 'Plataforma de e-commerce, otimizada para performance e escalabilidade em grandes lojas online.',
        },
        supabase: {
          name: 'Supabase',
          description: 'Backend open source completo com autenticação, banco de dados e API, alternativa moderna ao Firebase.',
        },
        laravel: {
          name: 'Laravel',
          description: 'Framework PHP elegante e produtivo, ideal para desenvolvimento rápido de aplicações web seguras.',
        },
        'kubernetes-k3s': {
          name: 'Kubernetes K3S',
          description: 'Sistema de orquestração de containers que automatiza implantação, escalabilidade e gerenciamento de aplicações.',
        },
        woocommerce: {
          name: 'WooCommerce',
          description: 'Plataforma de e-commerce flexível e personalizável, baseada em WordPress, ideal para lojas online de pequeno a grande porte, com ampla variedade de plugins, temas e integrações.',
        },
        openclaw: {
          name: 'OpenClaw',
          description: 'Agente de IA flexível e personalizável, de código aberto, executado em VPS, com memória persistente, integrações e atuação autônoma em nome do usuário.',
        },
      },
    },
    currentSo: {
      title: 'Sistema operacional atual',
      addons: {
        title: 'Adicionado no seu Sistema Operacional',
        application: 'Aplicação',
      },
    },
    changeApplications: {
      title: 'Alterar sistema operacional ou aplicação',
      description: 'No momento, para alterar o sistema operacional do seu VPS, é necessário abrir um chamado com o time de suporte. Selecione o sistema desejado para ser redirecionado ao formulário de abertura.',
      tabs: {
        operationalSystems: 'SO Simples',
        panels: 'SO com Painel',
        applications: 'Aplicação',
      },
      modal: {
        operationalSystems: {
          title: 'Alterar sistema operacional',
          placeholder: {
            versions: 'Selecionar versão',
          },
          withoutSelectionOfVersion: {
            closeButton: 'Cancelar',
            confirmButton: 'Continuar',
          },
          withSelectionOfVersion: {
            closeButton: 'Cancelar',
            confirmButton: 'Continuar',
          },
          confirmWithoutPanelPaidActive: {
            message: (
              <>
                Ao instalar um novo sistema operacional,
                {' '}
                <strong>tudo que está salvo na sua VPS será apagado</strong>
                , incluindo arquivos, configurações, painéis e aplicativos.
              </>
            ),
            agreedTerms: [
              {
                text: 'Estou ciente de que tudo será apagado de forma permanente para a instalação do novo sistema operacional.',
                id: 'beDeleted',
              },
            ],
            closeButton: 'Voltar',
            confirmButton: 'Instalar agora',
          },
          confirmWithPanelPaidActive: {
            message: (formattedAddonsText = '') => (
              <>
                Ao instalar um novo sistema operacional,
                {' '}
                <strong>tudo que está salvo na sua VPS será apagado</strong>
                , incluindo arquivos, configurações, painéis e aplicativos.
                <br />
                <br />
                O novo sistema operacional não inclui o
                {' '}
                <strong>{formattedAddonsText}</strong>
                . Por isso,
                {' '}
                <strong>
                  {formattedAddonsText.includes(',') || formattedAddonsText.includes(' e ') ? 'suas licenças serão canceladas' : 'sua licença será cancelada'}
                </strong>
                {' '}
                e o valor remanescente reembolsado proporcionalmente.
              </>
            ),
            agreedTerms: (so = '', formattedAddonsText = '') => [
              {
                text: (
                  <>
                    Estou ciente de que todos os dados serão apagados de forma permanente para a instalação do novo sistema operacional com
                    {' '}
                    <strong>{so}</strong>
                    {' '}
                    e que
                    {' '}
                    {formattedAddonsText.includes(',') || formattedAddonsText.includes(' e ') ? 'as licenças' : 'a licença'}
                    {' '}
                    do
                    {' '}
                    <strong>{formattedAddonsText}</strong>
                    {' '}
                    {formattedAddonsText.includes(',') || formattedAddonsText.includes(' e ') ? 'serão canceladas' : 'será cancelada'}
                    , com reembolso proporcional do valor remanescente.
                  </>
                ),
                id: 'beDeleted',
              },
            ],
            closeButton: 'Voltar',
            confirmButton: 'Instalar agora',
          },
        },
        panels: {
          title: 'Instalar sistema operacional com painel',
          placeholder: {
            optionsAccounts: 'Opções de contas',
            paymentFrequency: 'Periodicidade de pagamento',
          },
          qtyAccountsText: seats => `Até ${seats} contas`,
          provisioned: so => (
            <>
              Painel provisionado em
              {' '}
              <strong>{so}</strong>
            </>
          ),
          selectionPanels: {
            closeButton: 'Cancelar',
            confirmButton: 'Continuar',
          },
          confirmWithoutPanelPaidActive: {
            message: (panel = '') => (
              <>
                Ao instalar um novo sistema operacional com
                {' '}
                <strong>{panel}</strong>
                ,
                {' '}
                <strong>tudo que está salvo na sua VPS será apagado</strong>
                , incluindo arquivos, configurações, painéis e aplicativos.
              </>
            ),
            agreedTerms: (panel = []) => [
              {
                text: (
                  <>
                    Estou ciente de que tudo será apagado de forma permanente para a instalação do novo sistema operacional com
                    {' '}
                    <strong>{panel}</strong>
                  </>
                ),
                id: 'beDeleted',
              },
              {
                text: 'Entendo que a instalação somente será realizada após a compensação do pagamento, e que o prazo pode variar de acordo com o método escolhido.',
                id: 'paymentAcknowledgment',
              },
            ],
            closeButton: 'Voltar',
            confirmButton: 'Ir para pagamento',
          },
          confirmWithPanelPaidActive: {
            message: (panel = '', formattedAddonsText = '') => (
              <>
                Ao instalar um novo sistema operacional com
                {' '}
                <strong>{panel}</strong>
                ,
                {' '}
                <strong>tudo que está salvo na sua VPS será apagado</strong>
                , incluindo arquivos, configurações, painéis e aplicativos.
                <br />
                <br />
                O novo sistema operacional não inclui o
                {' '}
                <strong>{formattedAddonsText}</strong>
                . Por isso,
                {' '}
                <strong>
                  {formattedAddonsText.includes(',') || formattedAddonsText.includes(' e ') ? 'suas licenças serão canceladas' : 'sua licença será cancelada'}
                </strong>
                {' '}
                e o valor remanescente reembolsado proporcionalmente.
              </>
            ),
            agreedTerms: (panel = '', formattedAddonsText = '') => [
              {
                text: (
                  <>
                    Estou ciente de que todos os dados serão apagados de forma permanente para a instalação do novo sistema operacional com
                    {' '}
                    <strong>{panel}</strong>
                    {' '}
                    e que
                    {' '}
                    {formattedAddonsText.includes(',') || formattedAddonsText.includes(' e ') ? 'as licenças' : 'a licença'}
                    {' '}
                    do
                    {' '}
                    <strong>{formattedAddonsText}</strong>
                    {' '}
                    {formattedAddonsText.includes(',') || formattedAddonsText.includes(' e ') ? 'serão canceladas' : 'será cancelada'}
                    , com reembolso proporcional do valor remanescente.
                  </>
                ),
                id: 'beDeleted',
              },
              {
                text: 'Entendo que a instalação somente será realizada após a compensação do pagamento, e que o prazo pode variar de acordo com o método escolhido.',
                id: 'paymentAcknowledgment',
              },
            ],
            closeButton: 'Voltar',
            confirmButton: 'Ir para pagamento',
          },
        },
        applications: {
          title: 'Instalar sistema operacional com aplicação',
          provisioned: so => (
            <>
              Aplicação provisionada em
              {' '}
              <strong>{so}</strong>
            </>
          ),
          selectionApplication: {
            closeButton: 'Cancelar',
            confirmButton: 'Continuar',
          },
          selectionDomain: {
            message: 'Essa aplicação precisa de um domínio para funcionar corretamente. Escolha como você quer seguir.',
            closeButton: 'Voltar',
            confirmButton: 'Continuar',
            alreadyHasDomain: {
              label: 'Usar um domínio que já possuo',
              input: {
                label: 'Insira seu domínio',
                helpText: '(ex.: seudominio.com.br)',
                errorMessage: 'Insira um domínio válido.',
              },
            },
            needToRegisterDomain: {
              label: 'Registrar um novo domínio',
              description: (
                <>
                  <p>Não tem um domínio ainda? Você pode registrar um agora. Você será direcionado para a contratação de domínio e a instalação da aplicação será interrompida.</p>
                  <p>Depois de registrar o domínio, volte para a seleção de aplicações e inicie a instalação novamente usando o domínio comprado.</p>
                </>
              ),
            },
          },
          confirmWithoutPanelPaidActive: {
            message: (application = '') => (
              <>
                Ao instalar um novo sistema operacional com
                {' '}
                <strong>{application}</strong>
                ,
                {' '}
                <strong>tudo que está salvo na sua VPS será apagado</strong>
                , incluindo arquivos, configurações, painéis e aplicativos.
              </>
            ),
            agreedTerms: (application = '') => (
              [
                {
                  text: (
                    <>
                      Estou ciente de que tudo será apagado de forma permanente para a instalação do novo sistema operacional com
                      {' '}
                      <strong>{application}</strong>
                      .
                    </>
                  ),
                  id: 'beDeleted',
                },
              ]
            ),
            closeButton: 'Voltar',
            confirmButton: 'Instalar agora',
          },
          confirmWithPanelPaidActive: {
            message: (application = '', formattedAddonsText = '') => (
              <>
                Ao instalar um novo sistema operacional com
                {' '}
                <strong>{application}</strong>
                ,
                {' '}
                <strong>tudo que está salvo na sua VPS será apagado</strong>
                , incluindo arquivos, configurações, painéis e aplicativos.
                <br />
                <br />
                O novo sistema operacional não inclui o
                {' '}
                <strong>{formattedAddonsText}</strong>
                . Por isso,
                {' '}
                <strong>
                  {formattedAddonsText.includes(',') || formattedAddonsText.includes(' e ') ? 'suas licenças serão canceladas' : 'sua licença será cancelada'}
                </strong>
                {' '}
                e o valor remanescente reembolsado proporcionalmente.
              </>
            ),
            agreedTerms: (application = '', formattedAddonsText = '') => [
              {
                text: (
                  <>
                    Estou ciente de que todos os dados serão apagados de forma permanente para a instalação do novo sistema operacional com
                    {' '}
                    <strong>{application}</strong>
                    {' '}
                    e que
                    {' '}
                    {formattedAddonsText.includes(',') || formattedAddonsText.includes(' e ') ? 'as licenças' : 'a licença'}
                    {' '}
                    do
                    {' '}
                    <strong>{formattedAddonsText}</strong>
                    {' '}
                    {formattedAddonsText.includes(',') || formattedAddonsText.includes(' e ') ? 'serão canceladas' : 'será cancelada'}
                    , com reembolso proporcional do valor remanescente.
                  </>
                ),
                id: 'beDeleted',
              },
            ],
            closeButton: 'Voltar',
            confirmButton: 'Instalar agora',
          },
        },
      },
    },
    rebuild: {
      title: 'Rebuild (reinstalação)',
      description: 'O rebuild recria o seu VPS do zero usando o mesmo sistema operacional. Serve pra restaurar o ambiente original e corrigir possíveis erros de configuração ou desempenho.',
      button: 'Fazer rebuild agora',
      modal: {
        confirmRebuild: {
          title: 'Rebuild VPS',
          message: (
            <>
              Ao realizar o rebuild, sua VPS será recriada do zero
              {' '}
              <strong>com o mesmo Sistema Operacional</strong>
              . Todos os dados e configurações serão apagados de forma irreversível.
            </>
          ),
          agreedTerms: [
            {
              text: 'Estou ciente de que tudo será apagado de forma permanente para a reinstalação do sistema operacional.',
              id: 'beDeleted',
            },
          ],
          closeButton: 'Cancelar',
          confirmButton: 'Fazer rebuild',
        },
        serverInactive: {
          title: 'VPS não disponível',
          message: 'A VPS não está pronta para uso ainda. Aguarde o provisionamento finalizar.',
          confirmButton: 'Entendi',
        },
        limitExceeded: {
          title: 'Limite diário de rebuilds atingido',
          message: (
            <>
              Você atingiu o
              {' '}
              <strong>limite de dois rebuilds</strong>
              {' '}
              (reinstalações do sistema operacional, seja o atual ou um novo) nas últimas 24 horas. Será possível realizar um novo amanhã.
            </>
          ),
          confirmButton: 'Entendi',
        },
        notFound: {
          title: 'Sua VPS está offline',
          message: 'A VPS está inativa no momento. Ative-a para continuar.',
          confirmButton: 'Entendi',
        },
        unknownError: {
          title: 'Rebuild não concluído',
          message: 'Não foi possível concluir o rebuild da sua VPS. Tente novamente em alguns instantes.',
          closeButton: 'Fechar',
          confirmButton: 'Tentar novamente',
        },
      },
      feedback: {
        loading: 'Rebuild em progresso. Isso pode levar alguns minutos. Aguarde...',
      },
    },
    modal: {
      alert: {
        backup: {
          title: 'Essa ação não poderá ser desfeita!',
          message: 'Antes de continuar, faça backup de todos os seus arquivos e informações importantes.',
          backup: {
            text: 'Saiba como fazer backup.',
            link: 'https://suporte.hostgator.com.br/hc/pt-br/articles/115000385173',
          },
        },
      },
    },
  },
  form: {
    changePlan: {
      title: 'Alteração de plano',
      defaultSelectedNeed: 'Alteração de Plano',
    },
  },
  messages: {
    vpsNotFound: 'VPS não encontrada. Por favor, verifique se o serviço está ativo ou entre em contato com o suporte.',
  },
};

export default { vpsOci };
